import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { AppContext, url } from "../../utils";
import Web3 from "web3";
import { formatUnits } from "@ethersproject/units";
import { HashLink } from "react-router-hash-link";
import moment from "moment";
import { toast } from "react-toastify";
import Loading from "../../loading";
import { Contract, ethers } from "ethers";
import createdPresaleAbi from "../../utils/createdPresaleAbi.json";
import CopyToClipboard from "react-copy-to-clipboard";
import { AiOutlineCopy } from "react-icons/ai";

let walletAddress = "0x8ba1f109551bD432803012645Ac136ddd64DBA72";

const provider = new ethers.providers.JsonRpcProvider(
  "https://data-seed-prebsc-1-s1.binance.org:8545/"
);

const VoidSigner = new ethers.VoidSigner(walletAddress, provider);
function handleClick(event) {
  event.preventDefault();
}
export default function ClosedProjectDetail() {
  let { id } = useParams();
  const matches = useMediaQuery("(max-width:700px)");
  const { account, connect, signer } = useContext(AppContext);

  const [Data, SetData] = useState([]);
  const [singleProject, setsingleProject] = useState({});
  const [state, setstate] = useState("0");
  const [presaleContract, setpresaleContract] = useState("");
  const [totalUsers, settotalUser] = useState(0);
  const [totalEarned, settotalEarned] = useState(0);
  const [ownerAddress, setownerAddress] = useState("");
  const [loading, setloading] = useState(false);

  const initData = async () => {
    const { data } = await axios.get(`${url}/presaleRouter/IODData/`);
    SetData(data.iod);
  };
  useEffect(() => {
    initData();
  }, []);
  useEffect(() => {
    const init = async () => {
      let findData = await Data.filter((item) => item._id == id);
      setsingleProject(findData[0]);
    };
    if (Data.length > 0) {
      init();
    }
  }, [Data]);

  const initContracts = async () => {
    try {
      const presale = signer
        ? new Contract(singleProject.presaleAddress, createdPresaleAbi, signer)
        : new Contract(
            singleProject.presaleAddress,
            createdPresaleAbi,
            VoidSigner
          );
      setpresaleContract(presale);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    initContracts();
  }, [singleProject, signer]);
  const initBalance = async () => {
    try {
      const totalRaisedAmount = await presaleContract.amountRaised();

      const owner = await presaleContract.tokenOwner();
      // const allow = await presaleContract.allow();
      const totalUser = await presaleContract.totalUser();
      setownerAddress(owner);
      settotalEarned(+formatUnits(totalRaisedAmount));
      settotalUser(+totalUser);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (presaleContract) {
      initBalance();
    }
  }, [presaleContract]);
  const ownerHandler = async () => {
    try {
      setloading(true);
      const tx = await presaleContract.withdrawAndInitializePool();
      await tx.wait();
      toast.success("Pool initialized successfully");
      setloading(false);
    } catch (error) {
      if (error?.data?.message) {
        toast.error(error?.data?.message);
      } else {
        toast.error(error?.message);
      }
      setloading(false);
    }
  };

  const claimHandler = async () => {
    try {
      setloading(true);
      const tx = await presaleContract.claim();
      await tx.wait();
      toast.success("Successfully claimed");
      setloading(false);
    } catch (error) {
      if (error?.data?.message) {
        toast.error(error?.data?.message);
      } else {
        toast.error(error?.message);
      }
      setloading(false);
    }
  };
  return (
    <>
      <Loading loading={loading} />
      <Box id="closed-project" pt={5} pb={10}>
        <Container maxWidth="lg">
          <Stack direction="row" spacing={1}>
            <Box fontFamily="Raleway">
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="breadcrumb">
                  <HashLink
                    to="/projects/#liveprojects"
                    smooth
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#05C3DE",
                    }}
                  >
                    Projects
                  </HashLink>
                  <Box
                    style={{ display: "flex", alignItems: "center" }}
                    color="inherit"
                  >
                    {singleProject?.projectName}
                  </Box>
                </Breadcrumbs>
              </div>
            </Box>
          </Stack>
          <Stack direction="row" spacing={3} my={4} alignItems="center">
            <Avatar sx={{ width: 70, height: 70 }}>
              <img src={singleProject.logoLink} />
            </Avatar>
            <Box>
              <Box fontFamily="Raleway" fontSize={{ xs: "20px", md: "42px" }}>
                {singleProject?.tokenName}
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 11px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={singleProject?.telegramLink}
                  target="_blank"
                >
                  <i className="fab fa-telegram-plane"></i>
                </a>

                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={singleProject?.twitterLink}
                  target="_blank"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={singleProject?.redditLink}
                  target="_blank"
                >
                  <i className="fab fa-reddit-alien"></i>
                </a>
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={singleProject?.webLink}
                  target="_blank"
                >
                  <i className="fal fa-globe"></i>
                </a>
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={singleProject?.githubLink}
                  target="_blank"
                >
                  <i className="fab fa-github-alt"></i>
                </a>
              </Box>
            </Box>
          </Stack>
          <Grid container mt={6}>
            <Grid item xs={12} md={12}>
              <img src={singleProject.coverImage} />
            </Grid>
          </Grid>
          <Box>
            <Stack
              direction="row"
              spacing={3}
              my={2}
              cursor="pointer"
              borderBottom="1px solid grey"
            >
              <Button
                size="large"
                style={{ color: "#fff", padding: "20px" }}
                onClick={() => {
                  setstate("0");
                }}
              >
                Description
              </Button>
              <Button
                size="large"
                style={{ color: "#fff", padding: "20px" }}
                onClick={() => {
                  setstate("1");
                }}
              >
                Token Sale
              </Button>
            </Stack>
            {state === "0" ? (
              <Box>
                <Grid item xs={12} md={6} px={2} mt={{ xs: 5, sm: 5, md: -1 }}>
                  <Box mb={8}>
                    <Box
                      fontFamily="Raleway"
                      fontSize={{ xs: "28px", md: "42px" }}
                      fontWeight="700"
                      // textAlign="center"
                    >
                      HEADINGS
                    </Box>
                    <Box
                      fontFamily="Raleway"
                      fontSize={{ xs: "20px", md: "24px" }}
                      letterSpacing={10}
                    >
                      HIGHLIGHTS
                    </Box>
                    <br />
                    <ul style={{ fontFamily: "Raleway" }}>
                      <li style={{ fontFamily: "Raleway" }}>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry.
                      </li>
                      <br />
                      <li style={{ fontFamily: "Raleway" }}>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s.
                      </li>
                      <br />
                      <li style={{ fontFamily: "Raleway" }}>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the
                        industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and
                        scrambled it to make a type specimen book.
                      </li>
                    </ul>
                  </Box>
                </Grid>
                <br />
              </Box>
            ) : (
              <Box my={4}>
                <Container maxWidth="lg">
                  <Grid container spacing={5}>
                    <Grid item xs={12} sm={8}>
                      <TableContainer
                        style={{ boxShadow: "#ffffff 0px 0px 15px -2px" }}
                        component={Paper}
                      >
                        <Table
                          style={{
                            color: "#fff",
                            background: "#271942",
                            boxShadow: "#ffffff 0px 0px 15px -2px",
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                sx={{ color: "#fff", fontFamily: "Raleway" }}
                              >
                                Project Key Metrics
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {account.toLowerCase() ==
                            ownerAddress.toLowerCase() ? (
                              <TableRow>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  borderBottom="1px solid #fff"
                                >
                                  <TableCell
                                    sx={{ color: "Grey", borderStyle: "none" }}
                                  >
                                    <Box
                                      fontWeight="500"
                                      fontSize="18px"
                                      textAlign="center"
                                      fontFamily="Raleway"
                                      px={1}
                                      py={1}
                                      borderRadius="20px"
                                      width="150px"
                                      onClick={() => ownerHandler()}
                                      style={{
                                        cursor: "pointer",
                                        color: "#ffffff",
                                        background:
                                          "linear-gradient(360deg, #26058E 50%, #A301F7)",
                                      }}
                                    >
                                      Initialize Pool
                                    </Box>
                                  </TableCell>
                                </Box>
                              </TableRow>
                            ) : null}
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Token Name
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  {singleProject.tokenName}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Token Symbol
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  {singleProject.tokenSymbol}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Token Decimals
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {singleProject.tokenDecimal}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Token Contract
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Snas",
                                  }}
                                >
                                  <Box display="flex" alignItems="center">
                                    {singleProject.tokenAddress.slice(0, 6) +
                                      "...." +
                                      singleProject.tokenAddress.slice(-4)}
                                    <CopyToClipboard
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                      }}
                                      text={singleProject.tokenAddress}
                                      onCopy={() => {
                                        toast.success("Contract Copied.");
                                      }}
                                    >
                                      <AiOutlineCopy />
                                    </CopyToClipboard>
                                  </Box>
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Sale Price
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {singleProject.presaleRate}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Dex Price
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {singleProject.pancakeListRate}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Sale Start Time (UTC)
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {moment
                                    .unix(+singleProject.startTime)
                                    .format("LL")}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Sale End Time (UTC)
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {moment
                                    .unix(+singleProject.endTime)
                                    .format("LL")}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Soft Cap
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {singleProject.softcap} BNB
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Hard Cap
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {singleProject.hardcap} BNB
                                </TableCell>
                              </Box>
                            </TableRow>

                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Amount Raised
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {totalEarned} BNB
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Total Particepents
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sana",
                                  }}
                                >
                                  {totalUsers}
                                </TableCell>
                              </Box>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        bgcolor="#271942"
                        borderRadius="10px"
                        boxShadow="#ffffff 0px 0px 15px -2px"
                        // height="100%"
                        px={3}
                        py={5}
                      >
                        <Box
                          fontWeight="500"
                          fontSize="25px"
                          fontFamily="Raleway"
                        >
                          Claim Your Tokens
                        </Box>
                        <Box
                          fontWeight="500"
                          fontSize="15px"
                          fontFamily="Raleway"
                          textAlign="center"
                        >
                          You can claim your tokens from here after initializing
                          the pool by owner
                        </Box>

                        {account ? (
                          <Box
                            mt={2}
                            fontWeight="500"
                            fontSize="18px"
                            textAlign="center"
                            fontFamily="Raleway"
                            px={3}
                            py={1}
                            borderRadius="20px"
                            width="250px"
                            onClick={() => claimHandler()}
                            style={{
                              cursor: "pointer",
                              background:
                                "linear-gradient(360deg, #26058E 50%, #A301F7)",
                            }}
                          >
                            Claim
                          </Box>
                        ) : (
                          <Box
                            mt={2}
                            fontWeight="500"
                            fontSize="18px"
                            textAlign="center"
                            fontFamily="Raleway"
                            width="250px"
                            px={3}
                            py={1}
                            borderRadius="20px"
                            onClick={() => connect()}
                            style={{
                              cursor: "pointer",
                              background:
                                "linear-gradient(360deg, #26058E 50%, #A301F7)",
                            }}
                          >
                            Connect Wallet
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Container>
              </Box>
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
}
